define( 'Footer',[ 'ANSI/Utility/SitecoreUtils', 'promise-polyfill' ], function ( sitecoreUtils ) {
    'use strict';

    function Footer() {}

    Footer.prototype = {
        constructor: Footer,
        init: function () {
            if ( document.body.contains( document.querySelector( 'footer' ) ) ) {
                Footer.prototype.socialBox();
            }
        },
        socialBox: function () {
            //Social button box in footer toggle
            var footer = document.querySelector( '.score-footer' );
            var btnBox = footer.querySelector( '.score-well' );

            var toggle = function toggle() {
                btnBox.classList.toggle( 'open' );
                socialBtn.classList.toggle( 'open' );
            };


            var socialBtn = footer.querySelector( '.js-social-btn img' );
            socialBtn.addEventListener( 'click', toggle );

            btnBox.addEventListener( 'keydown', function ( e ) {
                if ( btnBox.classList.contains( 'open' ) && e.keyCode == 27 ) {
                    btnBox.classList.remove( 'open' );
                    socialBtn.classList.remove( 'open' );
                }
            } )

            footer.querySelector( '.js-social-btn' ).addEventListener( 'keydown', function ( e ) {
                if ( e.keyCode == 13 ) toggle();
            } );

            document.onclick = function ( event ) {
                event.stopPropagation();
                var opened = footer.querySelector( '.score-well.open' );
                if ( event.target !== socialBtn && event.target !== opened ) {
                    btnBox.classList.remove( 'open' );
                    socialBtn.classList.remove( 'open' );
                }
            };
        }
    };
    if ( !sitecoreUtils.prototype.isEditing() ) Promise.resolve().then( Footer.prototype.init );
} );
